import { myAxios } from "./axios"

export function getFines(data, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(data || {})

        },
    }
    return myAxios.get("/fines", config)
}

export function getFine(id) {
    return myAxios.get("/fines/" + id)
}

export function addFine(data) {
    return myAxios.post("/fines/create", data)
}

export function editFine(id, data) {
    return myAxios.put("/fines/" + id + "/update", data)
}

export function deleteFine(id) {
    return myAxios.delete("/fines/" + id + "/delete")
}
